/**
 * Support Request Constants
 */

export const SUPPORT_REQUEST_TITLE_OPTIONS = [
  { value: '', label: '選択して下さい' },
  { value: '操作方法について', label: '操作方法について' },
  { value: '請求関係について', label: '請求関係について' },
  { value: 'システム環境について', label: 'システム環境について' },
  { value: 'その他', label: 'その他' },
];

export const SERVICE_TYPE_FALLBACK: Record<string, string> = {
  A2: 'はり・きゅう',
  R2: 'マッサージ',
  BOTH: 'はり・きゅう、マッサージ',
};
